import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import Typography from "@app/sharedComponents/typography/Typography";
import { themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { ColorTokens } from "@voltmoney/schema";
import { FAQ_TYPE, REPAY_TITLE, useDarkMode } from "@app/utils";
import { TypographyTypeDLS } from "@voltmoney/schema";
import { useState } from "react";
import { FlatList, Linking, Platform, ScrollView, TextInput, View } from "react-native";
import { formatIndianCurrency } from "@app/utils/utility";
import { useAppSelector } from "@app/store/hooks";
import { LENDER_ID } from "@app/types/regix";
import Button from "@app/sharedComponents/Button/Button";
import YesIconRevamp from "../../../assets/Icons/YesIconRevamp";
import NoIconRevamp from "../../../assets/Icons/NoIconRevamp";
import SmileFaceIconRevamp from "../../../assets/Icons/SmileFaceIconRevamp";
const FaqDetailsRevamp = ({navigation,route}: {navigation: any; route: any} ) => {
    const {title,data} = route?.params;
    const loanDetailsObj = useAppSelector((state) => state.auth.loanDetails);
    const userDetails = useAppSelector((state) => state.auth.userDetails);
    const isDarMode  = useDarkMode()
    const creditLimit = loanDetailsObj?.loanDetails?.actualLoanAmount;
    const interestRate = loanDetailsObj?.interestDetails?.interestRate;
    const interestDueDate =  userDetails?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.TATA ? '3rd' : '7th';

    const [openFeedbackCard,setOpenFeedbackCard] = useState(false);
    const [isQueryResolved,setQueryResolved] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [feedbackInput,setFeedbackInput]  = useState('');
    const closeBottomSheet = () => {
      setOpenFeedbackCard(false);
    }

    const renderModal = () => {
      return (
        <ThemedView p="lg" >
            <ThemedText
                variant="h3s"
                color="text-primary"
            >
                Help us improve
            </ThemedText>
            <ThemedView style={{marginTop:16}}>
                <TextInput
                style={[
                    {width: "100%", borderWidth: 1,borderColor: isFocused ? '#E4E7EC' : "#E4E7EC",
                    borderRadius: 4,paddingVertical: 12,paddingLeft:16,paddingRight:12,fontSize: 14,overflow: 'hidden',
                    color:isDarMode ?  'white' : '#1D2939',textAlignVertical: "top", height:120},
                    Platform.OS === 'web' && {
                        //@ts-ignore
                        outlineStyle: 'none',
                    },
                    ]}
                    
                    value={feedbackInput}
                    onChangeText={setFeedbackInput}
                    placeholder="Tell us what you didn't understand in the article"
                    maxLength={500} 
                    multiline
                    onFocus={() => {
                        setIsFocused(true)
                    } }
                    onBlur={() => setIsFocused(false)}
                />
            </ThemedView>
            <ThemedView pt="lg">
                <Button type="SOLID" size="MD" label="Submit" handlePress={() => {
                      setQueryResolved(true);
                      setOpenFeedbackCard(false);
                    //   await triggerAction({
                    //     ...trackFaqInstrumentAction,
                    //     payload: {
                    //         type:'FAQ_NO_REASON',
                    //         eventProverty : 'remarks',
                    //         question: title,
                    //         result : feedbackInput,
                    //         ...trackFaqInstrumentAction.payload
                    //     }
                    // })
                }}/>
            </ThemedView>
        </ThemedView>
      )
    }

    const renderOrder:FAQ_TYPE[] = [];
        Object.keys(data).forEach((key) => {
            if (data[key] && Array.isArray(data[key]) && data[key].length > 0) {
                renderOrder.push(key as FAQ_TYPE);
            }
    });

    const replacePlaceholders = (subtitle: string) => {
      let formattedText = subtitle.replace("{{InterestDueDate}}", interestDueDate);
      formattedText = formattedText.replace("{{creditLimit}}", formatIndianCurrency(creditLimit));
      formattedText = formattedText.replace("{{interestRate}}", interestRate);
      return formattedText;
    }

    const renderBottomModal = () => {
      return (
        <ThemedView px="lg" py="lg" borderTopWidth={1} borderTopColor='border-primary' backgroundColor="bg-fill-primary">
          <Button type="OUTLINED" size="MD" label={'Proceed to close account'} 
          handlePress={() => {
            navigation.navigate('HOW_TO_CLOSE_ACCOUNT');        
          }}/>
        </ThemedView>
    )
    }

    const handleButtonPress = (type: string) => {
      if(type === 'REPAY'){
        navigation.navigate('FLEXI_PAY');       
      } else if(type === 'DELETE'){
        data?.button?.[0]?.link && Linking.openURL(data?.button[0]?.link);
      }
    }
    
    const renderButtonModal = ({data}: {data: any}) => {
      const type = data?.button[0]?.type;
      //Need to add divider
      return (
          <ThemedView px="lg" py="lg" borderTopWidth={1} borderTopColor='border-primary' backgroundColor="bg-fill-primary">
            <Button type="OUTLINED" size="MD" label={data?.button[0]?.title} 
            handlePress={() => handleButtonPress(type)}/>
          </ThemedView>
      )
    }

    const nestedDescription = () => {
      return (
          <FlatList
              data={data?.nestedDescription}
              keyExtractor={(item, index) => `nested-${index}`}
              renderItem={({ item }) => {
                  const updatedSubtitle = replacePlaceholders(item?.subtitle);
                  return (
                      <ThemedView style={{flexDirection:'row'}}>
                          <ThemedView style={{marginRight:4,marginTop:8,alignItems:'center'}}> 
                              <ThemedText
                                  variant="b1r"
                                  color="text-primary"
                              >{`\u2022`}</ThemedText>
                          </ThemedView>
                          <ThemedView style={{ flexDirection:'row',flexWrap:'wrap',marginTop:12,flex:1,alignItems:'center'}}>
                              <ThemedText
                                  variant="b3r" 
                                  color="text-primary"
                              >{`${item?.title} `}</ThemedText>
                              <ThemedText
                                  variant="b3r"
                                  color="text-secondary"
                              >{updatedSubtitle}</ThemedText>
                          </ThemedView>
                      </ThemedView>
                  );
              }}
          />
      )
    }

    const renderDescription = () => {
        return (
            <FlatList
                data={data?.descriptions}
                keyExtractor={(item, index) => `desc-${index}`}
                renderItem={({ item }) => {
                    const updatedSubtitle = replacePlaceholders(item?.description);
                    return (
                        <ThemedView style={{marginTop:16}}>
                            <ThemedText
                                variant="b3r"
                                color={"text-secondary"}
                            >{updatedSubtitle}</ThemedText>
                        </ThemedView>
                    );
                }}
            />
        )
    }

    const renderExample = () => {
        return (
            <FlatList
                data={data.examples}
                keyExtractor={(item, index) => `example-${index}`}
                renderItem={({ item }) => {
                    const updatedSubtitle = replacePlaceholders(item?.subtitle);
                    return (
                        <ThemedView style={{marginTop:16}}>
                            <ThemedText
                                variant="b1b"
                                color="text-primary"
                            >{item?.title}</ThemedText>
                            <ThemedText
                                variant="b3r"
                                color="text-secondary"
                            >{updatedSubtitle}</ThemedText>
                        </ThemedView>
                    );
                }}
            />
        )
    }

    const renderArrayExamples = () => {
        return(
            <ThemedView style={{marginTop:16}}>
                <ThemedText
                    variant="b3s"
                    color="text-primary"
                >Example:</ThemedText>
                <FlatList
                    data={data.arrayExamples}
                    keyExtractor={(item, index) => `example-${index}`}
                    renderItem={({ item }) => (
                        <ThemedView style={{marginLeft:4}}>
                            <ThemedText
                                variant="b3r"
                                color="text-secondary"
                            >{`- ${item?.subtitle}`}</ThemedText>
                        </ThemedView>
                    )}
                />
            </ThemedView>
        )
    }

    const renderNestedExampleDescription = () => {
        return (
            <ThemedView style={{marginTop:16}}>
                <ThemedText
                    variant="b3s"
                    color="text-primary"
                >{data.nestedExampleDescription[0].title}</ThemedText>
                <FlatList
                    data={data.nestedExampleDescription}
                    keyExtractor={(item, index) => `example-${index}`}
                    renderItem={({ item }) => (
                        <ThemedView style={{marginLeft:4}}>
                            <ThemedText
                                variant="b3r"
                                color="text-secondary"
                                >{`- ${item?.subtitle}`}</ThemedText>
                        </ThemedView>
                    )}
                />
            </ThemedView>
        )
    }

    const renderOtherDescription = () => {
        return (
            <FlatList
                data={data?.otherDescriptions}
                keyExtractor={(item, index) => `desc-${index}`}
                renderItem={({ item }) => (
                    <ThemedView style={{marginTop:16}}>
                        <ThemedText
                            variant="b3r"
                            color="text-secondary"
                        >{item?.description}</ThemedText>
                    </ThemedView>
                )}
            />
        )
    }

    const renderCloseAccountDetails = () => {
      return(
          <FlatList
              data={data?.closeAccount}
              keyExtractor={(item, index) => `desc-${index}`}
              renderItem={({ item }) => {
                  const updatedSubtitle = replacePlaceholders(item?.description);
                  return (
                      <ThemedView style={{flexDirection:'row'}}>
                          <ThemedView style={{marginRight:4,marginTop:16,alignItems:'center'}}> 
                              <ThemedText
                                  variant="b1r" 
                                  color="text-primary"
                              >{`\u2022`}</ThemedText>
                          </ThemedView>
                          <ThemedView style={{flexDirection:'row',flexWrap:'wrap',marginTop:16,flex:1,alignItems:'center'}}>
                              <ThemedText
                                  variant="b3r"
                                  color="text-secondary" 
                              >{updatedSubtitle}</ThemedText>
                          </ThemedView>
                      </ThemedView>
                  );
              }}
          />
      )
    }

    const renderCommonComp = () => {
      return (
          <ThemedView style={{marginTop:24}}>
              <ThemedText
                  variant="b3s"
                  color="text-primary"
              >
                  Was your query answered?
              </ThemedText>
              {isQueryResolved ? (
                  <ThemedView backgroundColor="bg-fill-emphasis-primary-1" style={{borderRadius:8,paddingHorizontal:12,paddingVertical:8,flexDirection:'row',alignItems:'center',alignSelf: 'flex-start',marginTop:12}}>
                      <SmileFaceIconRevamp />
                      <ThemedView style={{marginLeft:8}}>
                          <ThemedText
                              variant="b3s"
                              color="text-action-primary"
                          >
                              Thanks for your feedback
                          </ThemedText>
                      </ThemedView>
                  </ThemedView>
              ) : (
                  <ThemedView style={{marginTop:12,flexDirection:'row'}}>
                    <ThemedPressable 
                    eventName="FAQ_QUERY_RESOLVED"
                    eventProperty={{ question : title, result : 'yes'}}
                      onPress={async() => {
                          setQueryResolved(true);

                          // await triggerAction({
                          //     ...trackFaqInstrumentAction,
                          //     payload: {
                          //         type:'FAQ_QUERY_RESOLVED',
                          //         eventProverty : 'result',
                          //         result : 'yes',
                          //         question: title,
                          //         ...trackFaqInstrumentAction.payload
                          //     }
                          // })
                      }} 
                      alignItems="center"
                      flexDirection="row"
                      borderWidth={1}
                      borderRadius="sm"
                      py="sm"
                      backgroundColor="bg-fill-emphasis-primary-1"
                      px="md"
                      mr="sm"
                      >
                    <YesIconRevamp />
                          <ThemedView style={{marginLeft:4}}>
                              <ThemedText
                                  variant="b3r"
                                  color="text-primary"
                              >
                                  Yes
                              </ThemedText>
                          </ThemedView>
                      </ThemedPressable>
                      <ThemedPressable
                       eventName="FAQ_QUERY_RESOLVED"
                       eventProperty={{ question : title, result : 'No'}}
                        alignItems="center"
                      flexDirection="row"
                      borderWidth={1}
                      borderRadius="sm"
                      py="sm"
                      backgroundColor="bg-fill-emphasis-primary-1"
                      px="md"
                      mr="sm"
                          onPress={async() => {
                          setOpenFeedbackCard(true);
                          // await triggerAction({
                          //     ...trackFaqInstrumentAction,
                          //     payload: {
                          //         type:'FAQ_QUERY_RESOLVED',
                          //         eventProverty : 'result',
                          //         result : 'No',
                          //         question: title,
                          //         ...trackFaqInstrumentAction.payload
                          //     }
                          // })
                      }}>
                          <NoIconRevamp />
                          <ThemedView style={{marginLeft:4}}>
                              <ThemedText
                                  variant="b3r"
                                  color="text-primary"
                              >
                                  No
                              </ThemedText>
                          </ThemedView>
                      </ThemedPressable>
                  </ThemedView>
              )
              }
          </ThemedView>
      )
    }

    
    const renderData = (type: FAQ_TYPE) => {
      if(type === FAQ_TYPE.NESTED_DESCRIPTION){
          return nestedDescription()
      } else if (type === FAQ_TYPE.DESCRIPTIONS){
          return renderDescription()
      } else if (type === FAQ_TYPE.EXAMPLES){
          return renderExample();
      } else if(type === FAQ_TYPE.ARRAY_EXAMPLES){
          return renderArrayExamples();
      } else if (type === FAQ_TYPE.NESTED_EXAMPLE_DESCRIPTION){
          return renderNestedExampleDescription();
      } else if(type === FAQ_TYPE.OTHER_DESCRIPTIONS){
          return renderOtherDescription();
      } else if(type === FAQ_TYPE.CLOSE_ACCOUNT){
          return renderCloseAccountDetails();
      }
    }


    return (
      <>
      <PageHeaders label="FAQs" pageName={route?.name} navigation={navigation}/>
      <ScrollView style={{backgroundColor:themeColorSet["bg-surface-primary"] , flex:1}}>
        <ThemedView mt="2xl" px="lg" pb="lg">
          <ThemedText 
                variant="b2s"
                color="text-primary"
          >
              {title}
          </ThemedText>
          {renderOrder.map((type) => renderData(type))}
          {!renderOrder.includes(FAQ_TYPE.CLOSE_ACCOUNT) && renderCommonComp()}
        </ThemedView>
      </ScrollView>
      <BottomSheetContainer
          isVisible={openFeedbackCard}
          close={closeBottomSheet}
          closeOnBackdropPress={true}
          borderTopRightRadius={10}
          borderTopLeftRadius={10}
          onClose={undefined} 
          dragComponent={undefined} 
          containerStyle={undefined}>
            {renderModal()} 
      </BottomSheetContainer>
      {renderOrder.includes(FAQ_TYPE.CLOSE_ACCOUNT)  && renderBottomModal()}
      {renderOrder.includes(FAQ_TYPE.BUTTON) && renderButtonModal({data})}
      </>
    )
  }             

export default FaqDetailsRevamp;